import { useQuery } from '@tanstack/react-query';

import { exercisesService } from '../services';

import { exercisesKeys } from './useExercises';

export function useExercise(id: string | undefined) {
  return useQuery({
    queryKey: exercisesKeys.detail(id ?? ''),
    queryFn: () => {
      if (!id) throw new Error('missing id');
      return exercisesService.get(id);
    },
    enabled: Boolean(id),
  });
}
